<template>
  <div>
    <Movementmenu />
    <v-container fluid class="grey lighten-4 pa-6">
      <v-row dense class="mb-4">
        <v-col cols="12" md="3" v-for="(stat, i) in summaryStats" :key="i">
          <v-card
            class="rounded-lg shadow-sm border-left-lg"
            :style="{ borderLeftColor: stat.color }"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-2 grey--text">{{ stat.title }}</div>
                <v-list-item-title
                  class="headline mb-1 font-weight-bold"
                  :class="stat.color + '--text'"
                >
                  {{ stat.value }} <small class="caption grey--text">ราย</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="48" :color="stat.color + ' lighten-4'">
                <v-icon :color="stat.color">{{ stat.icon }}</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <base-material-card
        icon="mdi-account-details"
        title="รายละเอียดการขอย้ายเชิงลึก (ประมวลผลแบบที่ 1)"
        color="primary"
      >
        <v-card class="mb-6 pa-4 rounded-lg grey lighten-5" flat>
          <v-row align="center">
            <v-col cols="12" md="8" class="d-flex flex-wrap" style="gap: 8px;">
              <v-btn
                small
                rounded
                dark
                color="indigo"
                :href="reportLinks.raw"
                target="_blank"
              >
                <v-icon left>mdi-printer</v-icon> ข้อมูลดิบ
              </v-btn>
              <v-btn
                small
                rounded
                dark
                color="cyan"
                :href="reportLinks.additional"
                target="_blank"
              >
                <v-icon left>mdi-printer</v-icon> รายงานเพิ่มเติม
              </v-btn>
              <v-btn
                small
                rounded
                dark
                color="amber darken-2"
                :href="reportLinks.score"
                target="_blank"
              >
                <v-icon left>mdi-file-chart</v-icon> แบบคะแนน (7)
              </v-btn>
              <v-btn
                small
                rounded
                outlined
                color="success"
                @click="exportToExcel"
              >
                <v-icon left>mdi-file-excel</v-icon> ส่งออก Excel
              </v-btn>
            </v-col>
            <v-col cols="12" md="4" class="text-right">
              <v-btn
                small
                rounded
                color="error"
                depressed
                @click="search_not_confirm_submit"
              >
                <v-icon left>mdi-account-alert</v-icon> รายการไม่บันทึก
              </v-btn>
              <v-btn
                small
                rounded
                color="warning"
                depressed
                @click="transference_locationQueryCC"
                class="ml-2"
              >
                <v-icon left>mdi-cancel</v-icon> รายการยกเลิก
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <v-row dense class="px-2">
          <v-col cols="12" md="6">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="ค้นหารายชื่อ, รหัสบัตร, หรือสถานศึกษา..."
              outlined
              dense
              class="rounded-lg bg-white"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="ปรับแต่งการแสดงผลคอลัมน์"
              multiple
              outlined
              dense
              return-object
              class="rounded-lg bg-white"
              hide-details
            >
              <template v-slot:selection="{ index }">
                <v-chip x-small v-if="index < 2"
                  ><span>{{ selectedHeaders[index].text }}</span></v-chip
                >
                <span v-if="index === 2" class="grey--text caption"
                  >(+{{ selectedHeaders.length - 2 }})</span
                >
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="6">
            <div>
              <v-autocomplete
                label="ค้นหาจากจังหวัด"
                v-model="searchProvince"
                :items="province"
                item-value="province_ID"
                item-text="province_name"
                outlined
                dense
                @change="searchProvinceQuery()"
              ></v-autocomplete>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <div>
              <v-autocomplete
                label="ค้นหาจากภาค"
                v-model="searchRegion"
                :items="region"
                item-value="region_ID"
                item-text="region_name"
                outlined
                dense
                @change="searchRegionQuery()"
              ></v-autocomplete>
            </div>
          </v-col>
        </v-row>

        <v-data-table
          :headers="showHeaders"
          :items="transference_locations"
          :search="search"
          :loading="loading"
          :item-class="row_classes"
          class="elevation-0 mt-4 custom-table"
        >
          <template v-slot:item.new_college="{ item }">
            <div class="blue--text font-weight-medium">
              {{ item.new_college }}
            </div>
            <div class="caption font-italic">
              ลำดับขอย้าย: {{ item.tlsequence_n }}
            </div>
          </template>

          <template v-slot:item.status_position="{ item }">
            <v-chip
              v-if="item.status_position"
              color="success"
              x-small
              dark
              label
              >เปิดรับ</v-chip
            >
            <v-chip v-else color="grey lighten-1" x-small dark label
              >ปิด</v-chip
            >
          </template>

          <template v-slot:item.comment_dr_c="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-bind="attrs"
                  v-on="on"
                  small
                  :color="getCommentColor(item.comment_dr_c)"
                  dark
                  class="font-weight-bold"
                >
                  {{ getCommentText(item.comment_dr_c) }}
                </v-chip>
              </template>
              <span>{{
                item.detail_comment || "ไม่มีรายละเอียดเพิ่มเติม"
              }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.status_document="{ item }">
            <v-chip
              x-small
              outlined
              :color="getDocColor(item.status_document)"
              class="mt-1"
            >
              {{ getDocText(item.status_document) }}
            </v-chip>
          </template>

          <template v-slot:item.tlMcommittee="{ item }">
            {{ item.tlstatus_transfer }}
            <v-chip
              v-if="item.tlMcommittee === 'approp'"
              color="green lighten-1"
              x-small
              dark
              >เห็นควร</v-chip
            >
            <v-chip
              v-else-if="item.tlMcommittee === 'inapprop'"
              color="orange"
              x-small
              dark
              @click="cancelFile(item.id_tfl)"
              >ไม่เห็นควร</v-chip
            >
            <div v-if="item.tlstatus_transfer === 'cc'">
              <v-icon
                color="red"
                small
                @click="cancelFile(item.id_tfl)"
                class="ml-1"
                >mdi-alert-circle</v-icon
              >
              ขอยกเลิก
            </div>
          </template>

          <template v-slot:item.MdocumentsLinkfile="{ item }">
            <v-btn
              v-if="item.MdocumentsLinkfile"
              icon
              color="success"
              :href="'/HRvecfiles/' + item.MdocumentsLinkfile"
              target="_blank"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <v-icon v-else color="grey lighten-3">mdi-file-off</v-icon>
          </template>

          <template v-slot:item.tpvecprovince_scoreFile="{ item }">
            <v-btn
              v-if="item.tpvecprovince_scoreFile"
              icon
              color="info"
              :href="'/HRvecfiles/' + item.tpvecprovince_scoreFile"
              target="_blank"
            >
              <v-icon>mdi-printer-eye</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.select_item="{ item }">
            <v-checkbox
              v-model="selected"
              :value="item"
              hide-details
              dense
              class="ma-0 pa-0"
            ></v-checkbox>
          </template>
        </v-data-table>
      </base-material-card>
    </v-container>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      top
      right
      rounded="pill"
    >
      <v-icon left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx"; // ต้องรัน npm install xlsx

export default {
  components: { Movementmenu },
  data() {
    return {
      loading: false,
      ApiKey: "HRvec2021",
      search: "",
      selected: [],
      snackbar: { show: false, color: "", icon: "", text: "" },
      transference_locations: [],
      periods: {},
      headers: [],
      selectedHeaders: [],
      headersMap: [
        {
          text: "เลือก",
          align: "center",
          value: "select_item",
          sortable: false
        },
        { text: "รหัสสถานศึกษา", align: "center", value: "new_college_code" },
        { text: "สถานศึกษาปลายทาง", align: "left", value: "new_college" },
        { text: "ว่าง", align: "center", value: "count_manpower" },
        { text: "On/Off", align: "center", value: "status_position" },
        { text: "ผู้ขอย้าย", align: "left", value: "id_cards" },
        { text: "ผู้ขอย้าย", align: "left", value: "frist_names" },
        { text: "สังกัดเดิม", align: "left", value: "old_college" },
        { text: "ความคิดเห็น ผอ.", align: "center", value: "comment_dr_c" },
        { text: "สรุปปลายทาง", align: "center", value: "tlMcommittee" },
        { text: "ไฟล์แนบ", align: "center", value: "MdocumentsLinkfile" },
        { text: "คะแนน", align: "center", value: "tpvecprovince_score" },
        {
          text: "วิทยาลัยที่ได้ย้าย",
          align: "center",
          value: "college_name_suss"
        }
      ],
      province: [],
      searchProvince: "",
      region: [],
      searchRegion: ""
    };
  },

  computed: {
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    },
    summaryStats() {
      const list = this.transference_locations;
      return [
        {
          title: "ผู้ขอย้ายทั้งหมด",
          value: list.length,
          icon: "mdi-account-group",
          color: "#1976D2"
        },
        {
          title: "ผอ.เห็นควร",
          value: list.filter(x => x.comment_dr_c === "approp").length,
          icon: "mdi-check-decagram",
          color: "#4CAF50"
        },
        {
          title: "ปลายทางเห็นควร",
          value: list.filter(x => x.tlMcommittee === "approp").length,
          icon: "mdi-office-building-marker",
          color: "#009688"
        },
        {
          title: "รอดำเนินการ",
          value: list.filter(x => !x.comment_dr_c).length,
          icon: "mdi-clock-fast",
          color: "#FF9800"
        }
      ];
    },
    reportLinks() {
      const { period_times, period_year } = this.periods;
      return {
        raw: `#/admin/print_report_movement_online/${period_times}/${period_year}/teach`,
        additional: `#/admin/print_report_movement_online_2/${period_times}/${period_year}/teach`,
        score: `#/admin/print_report_movement_formscore7/?period_times=${period_times}&period_year=${period_year}`
      };
    }
  },

  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },

  async mounted() {
    await this.periodQuery();
    await this.regionQuery();
    await this.provinceQuery();
    await this.transference_locationQueryAll();
  },

  methods: {
    async searchRegionQuery() {
      this.loading = true;
      try {
        let data = {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          region_ID: this.searchRegion
        };      

        let res = await this.$http.post(
          "transference_location_detail.php",
          data
        );
        this.transference_locations = res.data;
      } finally {
        this.loading = false;
      }
    },
    async searchProvinceQuery() {
      this.loading = true;
      try {
        let res = await this.$http.post("transference_location_detail.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          province_ID: this.searchProvince
        });
        this.transference_locations = res.data;
      } finally {
        this.loading = false;
      }
    },
    async provinceQuery() {
      let data = {
        ApiKey: this.ApiKey
      };
      let result = await this.$http.post("province.php", data);

      this.province = result.data;
    },

    async regionQuery() {
      let data = {
        ApiKey: this.ApiKey
      };
      let result = await this.$http.post("region.php", data);
      this.region = result.data;
    },
    async cancelFile(id_tfl) {
      let result = await this.$http.post("transference_location.php", {
        ApiKey: this.ApiKey,
        id_tfl: id_tfl
      });

      this.transference_locationsCc = result.data;
      let text =
        this.transference_locationsCc.frist_name +
        " " +
        this.transference_locationsCc.last_name;

      Swal.fire({
        title: "คุณต้องการเปลี่ยนสถานะ?",
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยกเลิกไฟล์แนบความคิดเห็นปลายทาง",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          this.transference_locationsCc.ApiKey = this.ApiKey;
          this.transference_locationsCc.tlstatus_transfer = "";
          this.transference_locationsCc.tlMcommittee = "";
          let resultdel = await this.$http.post("deletefile.php", {
            ApiKey: this.ApiKey,
            filename:
              "../HRvecfiles/" +
              this.transference_locationsCc.tlMdocumentsLinkfile
          });
          this.transference_locationsCc.tlMdocumentsLinkfile = "";

          let resultupdate = await this.$http.post(
            "transference_location.update.movein.php",
            this.transference_locationsCc
          );
          await this.transference_locationQueryAll();
        }
      });
    },

    async periodQuery() {
      let res = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable_process: "1",
        period_id: "301"
      });
      this.periods = res.data;
    },

    async transference_locationQueryAll() {
      this.loading = true;
      try {
        let res = await this.$http.post("transference_location_detail.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          tlstatus_transfer: "cc"
        });
        this.transference_locations = res.data;
      } finally {
        this.loading = false;
      }
    },

    async transference_locationQueryCC() {
      this.loading = true;
      let res = await this.$http
        .post("transference_location_detail.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          tlstatus_transfer: "cc"
        })
        .finally(() => (this.loading = false));
      this.transference_locations = res.data;
    },

    async search_not_confirm_submit() {
      this.loading = true;
      let res = await this.$http
        .post("transference_location.php", {
          ApiKey: this.ApiKey,
          not_confirm: "ok"
        })
        .finally(() => (this.loading = false));
      this.transference_locations = res.data;
    },

    exportToExcel() {
      // ดึงข้อมูลเฉพาะคอลัมน์ที่แสดงอยู่
      const dataToExport = this.transference_locations.map(item => {
        let obj = {};
        this.showHeaders.forEach(h => {
          if (h.value !== "select_item") obj[h.text] = item[h.value];
        });
        return obj;
      });

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Transference_Detail");
      XLSX.writeFile(wb, `Transfer_Report_${new Date().getTime()}.xlsx`);
    },

    getCommentColor(v) {
      if (v === "approp") return "green";
      if (v === "inapprop") return "orange";
      if (v === "suspend") return "red";
      return "grey lighten-1";
    },

    getCommentText(v) {
      const map = {
        approp: "เห็นควร",
        inapprop: "ไม่เห็นควร",
        suspend: "ระงับย้าย"
      };
      return map[v] || "ยังไม่บันทึก";
    },

    getDocColor(v) {
      if (v === "complete") return "success";
      if (v === "incomplete") return "warning";
      return "error";
    },

    getDocText(v) {
      const map = {
        complete: "สมบูรณ์",
        incomplete: "ไม่สมบูรณ์",
        do_not: "ไม่จัดส่ง"
      };
      return map[v] || "รอดำเนินการ";
    },

    row_classes(item) {
      return item.tlstatus_transfer === "cc" ? "yellow lighten-4" : "";
    }
  }
};
</script>

<style scoped>
.custom-table >>> thead th {
  background-color: #f1f3f4 !important;
  color: #3c4043 !important;
  font-weight: 600 !important;
}
.custom-table >>> tbody tr:hover {
  background-color: #f8f9fa !important;
}
.border-left-lg {
  border-left: 6px solid;
}
.shadow-sm {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24) !important;
}
</style>
